import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="main-footer">
            <p>All Right Reserved &copy; Bappy Das</p>
        </div>
    );
};

export default Footer;